import { render, staticRenderFns } from "./MailAuth.vue?vue&type=template&id=0fb8b0fe&scoped=true&"
import script from "./MailAuth.vue?vue&type=script&lang=ts&"
export * from "./MailAuth.vue?vue&type=script&lang=ts&"
import style0 from "./MailAuth.vue?vue&type=style&index=0&id=0fb8b0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8b0fe",
  null
  
)

export default component.exports